let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("drPzE")).then(() => parcelRequire('5yFT8'));